var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "root",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.815 10.4984H21.2423",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.69 5.42334V10.4983",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89003 17.7484C9.09125 17.7484 10.065 16.7746 10.065 15.5734C10.065 14.3722 9.09125 13.3984 7.89003 13.3984C6.68881 13.3984 5.71503 14.3722 5.71503 15.5734C5.71503 16.7746 6.68881 17.7484 7.89003 17.7484Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 17.7484C17.7913 17.7484 18.765 16.7746 18.765 15.5734C18.765 14.3722 17.7913 13.3984 16.59 13.3984C15.3888 13.3984 14.415 14.3722 14.415 15.5734C14.415 16.7746 15.3888 17.7484 16.59 17.7484Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.366 6.62539C18.9977 5.88879 18.2445 5.42334 17.4209 5.42334H4.265C3.46388 5.42334 2.815 6.07221 2.815 6.87334V14.8483C2.815 15.2485 3.1398 15.5733 3.54 15.5733H5.715C5.715 14.372 6.68868 13.3983 7.89 13.3983C9.09133 13.3983 10.065 14.372 10.065 15.5733H14.415C14.415 14.372 15.3887 13.3983 16.59 13.3983C17.7913 13.3983 18.765 14.372 18.765 15.5733H20.94C21.3402 15.5733 21.665 15.2485 21.665 14.8483V11.2233L19.366 6.62539Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.cfdf9a258fd0a647ce9ef6a7e27cb49d.svg";
export { ForwardRef as ReactComponent };